import { Box, Text, Flex, Hide } from '@galilee/lilee';
import { StyledSubtitle, UnmarginedPanel, InlineText, ItemTitle } from "./index";
import styled from 'styled-components';

const PexaParticipantContainer = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 40% 20% 20% 20%;
    justify-content: space-between;
    @media screen and (max-width: ${(p) => p.theme.breakpointsMax[4]}) {
        grid-template-columns: 1fr;
    }
`;
const Header = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 40% 20% 20% 20%;
    justify-content: space-between;
    border-bottom: 1px solid ${(p) => p.theme.colors.base10};
`;
const PexaParticipantCard = ({ pexaParticipants }) => {
    const renderStatus = (settlementAcceptanceStatus) => {
        if (settlementAcceptanceStatus === 'Accepted')
            return <Text color="success" fontSize="0">{settlementAcceptanceStatus}</Text>;        
        else return <Text fontSize="0">{settlementAcceptanceStatus}</Text>;        
    };    
    return (
        <UnmarginedPanel id="pexaParticipants">
            <Flex justifyContent="space-between">
                <StyledSubtitle>PEXA Participants</StyledSubtitle>
            </Flex>

            {Object.entries(
                (pexaParticipants ?? []).reduce((groups, participant) => {
                    const key = participant.workspaceId;
                    groups[key] = groups[key] || [];
                    groups[key].push(participant);
                    return groups;
                }, {})
            ).map(([workspaceId, participants]) => (
                <Flex flexDirection="column" key={workspaceId} mt="4">
                    <Flex justifyContent="space-between" alignItems="center">
                        <StyledSubtitle>Workspace: {workspaceId} - {participants?.[0]?.propertyAddress}</StyledSubtitle>
                    </Flex>

                    <Header>
                        <ItemTitle>Name</ItemTitle>
                        <Hide breakpoints={[0, 1, 2, 3, 4]}>
                            <ItemTitle>Role</ItemTitle>
                        </Hide>
                        <Hide breakpoints={[0, 1, 2, 3, 4]}>
                            <ItemTitle>{participants?.[0]?.settlementRTBDescription}</ItemTitle>
                        </Hide>
                    </Header>

                    <Flex flexDirection="column">
                        {participants.map((participant, idx) => (
                            <PexaParticipantContainer key={participant.participantName + idx} mt="4">
                                <Flex alignItems="flex-start" mb="1">
                                    <InlineText>{participant.participantName}</InlineText>
                                </Flex>
                                <InlineText alignItems="flex-start">{participant.roleName}</InlineText>
                                <InlineText alignItems="flex-start">
                                    {renderStatus(participant.settlementAcceptanceStatus)}
                                </InlineText>
                            </PexaParticipantContainer>
                        ))}
                    </Flex>
                </Flex>
            ))}
        </UnmarginedPanel>
    );
};

export default PexaParticipantCard;